import { Base } from '../base/components/base'
import { COLORS } from '../configs/config'
import { ABSOLUTE } from '../base/helpers/style'

export const View = () => {

    const base = Base('div') // Fragment later

    base.cssClass({
        height: '100vh',
        ...ABSOLUTE,
        position: 'relative',
        overflow: 'hidden',
    })

    return base
}